import {
	useEffect,useState
} from 'react';

function useWindowWidth() {
	let screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	const [width, setWidth] = useState(screenWidth);

	useEffect(() => {
		const handleResize = () => setWidth(screenWidth);
		window.addEventListener('resize',
			handleResize);
		return () => {
			window.removeEventListener('resize',
				handleResize);
		};
	});

	return width;
}

export default useWindowWidth;
